<template>
  <Details
    title="application"
    resource="applications"
    :base-path="basePath"
    data-provider="$raaDataProvider"
  >
    <template v-slot:side-panel>
      <DetailsSidePanel entity-title="application" new-entity></DetailsSidePanel>
    </template>
    <template v-slot:default="detailsProps">
      <ApplicationForm
        :on-submit="detailsProps.handleSubmit"
        :loading="detailsProps.loading"
        @close="detailsProps.redirectToList"
      />
    </template>
  </Details>
</template>

<script>
  import ModalNavigation from "@/mixins/ModalNavigation";
  import Details from "@/components/auth/details/Details";
  import DetailsSidePanel from "@/components/auth/details/DetailsSidePanel";
  import ApplicationForm from "@/views/auth/raa-devtools/applications/ApplicationForm";

  export default {
    name: "ApplicationCreate",
    components: {
      ApplicationForm,
      Details,
      DetailsSidePanel,
    },
    mixins: [ModalNavigation],
    computed: {
      basePath: function () {
        return this.$route.name.replace('create', 'index');
      }
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
